import { useTranslation } from 'react-i18next';
import { Tabs } from '@anytag/shared-atoms';
import { useUserPermissions, useUserRoles } from '@anytag/auth';

export interface AdvertiserTabsProps {
  advertiserId: number;
  header?: React.ReactNode;
}

export const AdvertiserTabs = ({ advertiserId, header, children }: React.PropsWithChildren<AdvertiserTabsProps>) => {
  const { t } = useTranslation();
  const { isAdminStaff } = useUserRoles();
  const { hideUserTab } = useUserPermissions();
  const params = { id: advertiserId.toString() };

  return (
    <Tabs
      options={[
        {
          end: true,
          label: t('Advertiser.Advertiser'),
          to: '/advertiser/$id',
          params
        },
        {
          end: true,
          label: t('User'),
          hidden: hideUserTab,
          to: '/advertiser/$id/users',
          params
        },
        {
          end: true,
          hidden: !isAdminStaff,
          label: t('Budget Allocation'),
          to: '/advertiser/$id/budget-allocation',
          params
        }
      ]}
      className="px-4"
    >
      {children}
    </Tabs>
  );
};
